<template>
  <div class="chips-container">
    <div class="content">
      <div class="signaturePad-container">
      <vueSignature ref="signature" :sigOption="signature.options" :w="'700px'" :h="'150px'"></vueSignature>
      </div>
    </div>
    <div class="btns-wrap">
      <v-btn depressed block class="primary-txt-btn __h68" @click="submitAnswer()">{{
        contentData.responses.submitbutton
      }}</v-btn>
      <v-btn
        depressed
        block
        class="grey-txt-btn __h68"
        @click="clearSignature"
        v-show="!contentData.hideErasebutton"
        >{{ contentData.responses.erasebutton }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import vueSignature from "vue-signature"

export default {
  components: {
    vueSignature,
  },
  data() {
    return {
      contentData: {
        responses: {
          submitbutton: "submit",
          erasebutton: "clear",
        },
        hideErasebutton: false,
      },
      signature: {
        options: {
          penColor: "rgb(0, 0, 0)",
          backgroundColor: "rgb(242,242,242)",
        }
      },
    }
  },
  methods: {
    // submit is treated similar as textBox as signature is transferred as base64 text!
    submitAnswer() {
      let newInput = {}
      const signature = this.getSignature()
      
      if (signature !== undefined) {
        newInput = {
          signaturebox: {
            enteredText: signature,
            skipped: false,
          },
        }
      } else {
        newInput = {
          signaturebox: {
            skipped: true,
          },
        }
      }
      console.log(newInput)
      this.$emit("submitAnswer", newInput)
    
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Signature Card")

      let updatedContent = {
        responses: {
          submitbutton: executableSystemAction.guiTemplateContent.submitbutton.text,
          erasebutton: executableSystemAction.guiTemplateContent.erasebutton.text,
        },
        hideErasebutton: executableSystemAction.guiTemplateContent.erasebutton.hidden,
      }

      this.contentData = updatedContent

      // clear signature on update
      this.clearSignature()
      console.log(updatedContent)
    },
    clearSignature(){
			var _this = this;
			_this.$refs.signature.clear();
    },
    // returns undefined if signature is empty or svg base64 otherwise 
    getSignature(){
			var _this = this;
      if (_this.$refs.signature.isEmpty() === true){
        return undefined
      }
      else {
        return _this.$refs.signature.save('image/svg+xml')
      }
    }
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>

<style></style>
